// extracted by mini-css-extract-plugin
module.exports = {"input":"deleteModal_input_1_I3H","inputContainer":"deleteModal_inputContainer_2UTYZ"};